/**
 * Resolves Wistia share URLs (…/s/{id}) via oEmbed and injects the player iframe.
 * Share link IDs are not valid media hashed IDs for direct embed URLs.
 */
if (!customElements.get('wistia-share-embed')) {
  class WistiaShareEmbed extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true') return;

      const url = this.getAttribute('data-wistia-url');
      if (!url) return;

      const container = this;

      fetch(`https://fast.wistia.net/oembed.json?url=${encodeURIComponent(url)}`)
        .then((res) => {
          if (!res.ok) throw new Error(`Wistia oEmbed HTTP ${res.status}`);
          return res.json();
        })
        .then((data) => {
          const wrap = document.createElement('div');
          wrap.innerHTML = data.html;

          const iframe = wrap.querySelector('iframe');
          if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.position = 'absolute';
            iframe.style.top = '0';
            iframe.style.left = '0';
            container.appendChild(iframe);
          }

          const scriptEl = wrap.querySelector('script[src]');
          if (scriptEl && !document.querySelector(`script[src="${scriptEl.src}"]`)) {
            document.body.appendChild(scriptEl);
          }

          container.dataset.loaded = 'true';
        })
        .catch((err) => {
          console.warn('Wistia share embed failed:', err); // eslint-disable-line no-console
        });
    }
  }

  customElements.define('wistia-share-embed', WistiaShareEmbed);
}
